module.exports = "/images/vendor/flag-icon-css/flags/4x3/sj.svg?ae547dbec390990657f9d8acd33fbea4";